import { classnames } from "@/utils";
import styles from "./BrandLogo.module.scss";

type Props = {
  centered?: boolean;
};

export default function BrandLogo({ centered }: Props) {
  return (
    <div
      className={classnames([styles.wrapper, centered && styles.centered])}
    />
  );
}
